export default __webpack_public_path__ + "static/faq_bg-22923e3f9da7c10ac78eb6176377e9ee.webp";